<template>
  <div class="empty">
    <template v-if="$slots.image">
      <slot name="image"></slot>
    </template>
    <img v-if="!$slots.image" :src="image" alt="">
    
    <template v-if="$slots.desc">
      <slot name="desc"></slot>
    </template>
    <p v-if="!$slots.desc" class="fz-16 yx-color-text-secondary">{{ desc }}</p>
    <div v-if="btnShow" class="mt-10">
      <el-button type="primary" @click="handleClick">{{ btnText }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isSearch: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: ''
    },
    btnShow: {
      type: [Boolean, Number],
      default: 0 || false
    }
  },
  computed: {
    image({isSearch}) {
      return require(isSearch ? '@/assets/public/empty-search-img.png' : '@/assets/public/empty-img.png')
    },
    desc({isSearch}) {
      return isSearch ? '暂无筛选数据' : '暂无数据'
    }
  },
  methods: {
    handleClick() {
      this.$emit('btnClick');
    }
  }
}
</script>
<style lang="less" scoped>
.empty {
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
  img {
    width: 160px;
    height: 160px;
  }
}
</style>